export function getSettings() {
    return {
        rrcShortcut: localStorage["rrcShortcut"] === "true",
        rdcScanningShortcut: localStorage["rdcScanningShortcut"] !== "false",
        hdcScanningShortcut: localStorage["hdcScanningShortcut"] !== "false",
        spiderShortcut: localStorage["spiderShortcut"] === "true"
    };
}
